import { useCallback, useEffect, useState } from "react";
import {
	applyAndPersistFontScale,
	readStoredFontScale,
	type FontScaleLevel,
} from "../lib/fontScale";

/**
 * Root font scale (−2…+2) with localStorage persistence.
 * Baseline 0 matches the design type scale; applies via documentElement.
 */
export function useFontScale() {
	const [level, setLevelState] = useState<FontScaleLevel>(() =>
		typeof window !== "undefined" ? readStoredFontScale() : 0,
	);

	useEffect(() => {
		applyAndPersistFontScale(level);
	}, [level]);

	const setLevel = useCallback((next: FontScaleLevel) => {
		setLevelState(next);
	}, []);

	return { level, setLevel };
}
